// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__-tShK","footer":"ModalFilter_footer__3Sin5"};